import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-text-decode',
  templateUrl: './scanDeviceText.component.html',
  styleUrls: ['./scanDeviceText.component.css'],
})

export class ScanDeviceTextComponent {
  @Output() customOnChange: EventEmitter<any> = new EventEmitter();
  public form!: FormGroup;

  constructor(private fb: FormBuilder) {

  }

  public filterDevicesByGUDID() {
    this.customOnChange.emit({ scannedCode: this.form.controls['query'].value });

    console.log('aa');
  }




  async ngOnInit(): Promise<void> {
    this.form = this.fb.group({
    });
    this.form.controls['query'] = this.fb.control('');


  }
  async ngOnDestroy() {
    
    console.log('TextScanner Component Unmount');
  }
}
